module.exports = __webpack_public_path__ + "static/015-d7e56d9b4fcf66018907fe1f9339e61b.png";